import styled from 'styled-components'

const LineStyle = styled.div`
	background-color: var(--cream);
	height: 9px;
	-webkit-clip-path: url(#my-clip-path);
	clip-path: url(#my-clip-path);
    overflow: hidden;

	&.orange {
		background-color: var(--orange);
	}

	.animLine {
        position: absolute;
        top: 0;
        left: 0;
		width: 100%;
		z-index: 1;
		background-color: var(--orange);
		height: 100%;
		transform: translateX(-100%);
		transition: var(--trTime2);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		.animLine {
			display: none;
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		.animLine {
			display: none;
		}
	}
`

export default LineStyle
